import {
  OrderManagement_ClosedOrders as closedOrders,
  OrderManagement_CancelledOrders as cancelledOrders,
} from './backend'
import moment from 'moment'
import * as jsonexport from 'jsonexport/dist'

const getClosedOrders = async (page, pageSize, sortBy, freetext, from, to) => {
  let {data} = await closedOrders({
    sortBy: sortBy,
    page: page,
    pageSize: pageSize,
    fulltextSearch: freetext,
    orderDateFrom: from,
    orderDateTo: to,
  })
  return data
}

const getCancelledOrders = async (
  page,
  pageSize,
  sortBy,
  freetext,
  from,
  to,
) => {
  let {data} = await cancelledOrders({
    sortBy: sortBy,
    page: page,
    pageSize: pageSize,
    fulltextSearch: freetext,
    cancellationDateFrom: from,
    cancellationDateTo: to,
  })
  return data
}

const downloadDataAsCsv = (csv, fn) => {
  if (csv == null) return
  let filename = fn && fn.length > 0 ? `${fn}.csv` : 'export.csv'
  if (!csv.match(/^data:text\/csv/i)) {
    csv = 'data:text/csv;charset=utf-8,' + '\uFEFF' + csv
  }
  let data = encodeURI(csv)
  let link = document.createElement('a')
  link.setAttribute('href', data)
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const transformJson = items => {
  let array = []
  let attributes = items
    .map(m => m.customer)
    .filter(f => f.customerAttributes.length > 0)
    .map(m => m.customerAttributes)
    .map(m => m[0].attributeName)
  for (let i = 0; i < items.length; i++) {
    for (let j = 0; j < items[i].orderItems.length; j++) {
      let json = {}
      json.cart = items[i].idSstCart
      json.order_date = moment(String(items[i].orderDate)).format('DD.MM.YYYY')
      json.customer_first_name = items[i].customer.firstName
      json.customer_last_name = items[i].customer.lastName

      json.customer_address = items[i].customer.address
      json.customer_zip = items[i].customer.zip
      json.customer_city = items[i].customer.city
      json.customer_country = items[i].customer.country

      json.currency = items[i].currency
      json.item_title = items[i].orderItems[j].title
      json.item_description = items[i].orderItems[j].description
      json.item_unit_price = items[i].orderItems[j].unitPrice
      json.item_quantity = items[i].orderItems[j].quantity
      json.item_total = items[i].orderItems[j].total
      json.item_title = items[i].orderItems[j].firstName

      json.payment_status =
        items[i].paymentType.status == 40 ? 'Bezahlt' : 'Nicht Bezahlt'

      attributes.forEach(element => {
        let elm = items[i].customer.customerAttributes.find(
          f => f.attributeName === element,
        )
        if (elm) {
          json[element] = elm.attributeValue
        }
      })
      array.push(json)
    }
  }
  return array
}

const getCurrentDate = () => {
  var d = new Date(),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [year, month, day].join('-')
}

const getCsv = async items => {
  return await jsonexport(items, {rowDelimiter: ';'})
}

const getCancelledOrdersAsCsv = async (total, sortBy) => {
  let {data} = await cancelledOrders({
    sortBy: sortBy,
    page: 1,
    pageSize: total,
  })
  downloadDataAsCsv(
    await getCsv(transformJson(data.results)),
    `Export_Bestellungen_Stornos_${getCurrentDate()}`,
  )

  return data
}

const getClosedOrdersAsCsv = async (total, sortBy) => {
  let {data} = await closedOrders({
    sortBy: sortBy,
    page: 1,
    pageSize: total,
  })
  downloadDataAsCsv(
    await getCsv(transformJson(data.results)),
    `Export_Bestellungen_Abgeschlossen_${getCurrentDate()}`,
  )
  return data
}

export default {
  getClosedOrders,
  getCancelledOrders,
  getClosedOrdersAsCsv,
  getCancelledOrdersAsCsv,
}
